<mat-expansion-panel (opened)="panelOpen = true" (closed)="panelOpen = false" hideToggle>
    <mat-expansion-panel-header class="py-5 px-4">
        <mat-panel-title class="d-flex">
            <div class="container d-flex flex-column">
                <h2 class="header-title" [class.complete]="form.valid && !form.pristine" [class.error]="!form.valid && !form.pristine">Basic Information</h2>
            </div>
            <div>
                <mat-icon *ngIf="form.pristine && !panelOpen" class="header-toggle">
                    expand_more
                </mat-icon>
                <mat-icon *ngIf="form.pristine && panelOpen" class="header-toggle">
                    expand_less
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && form.valid" class="header-toggle complete">
                    checked
                </mat-icon>
                <mat-icon *ngIf="!form.pristine && !form.valid" class="header-toggle error">
                    close
                </mat-icon>
            </div>
        </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="panel-body-container mx-2">
        <form [formGroup]="form">
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field class="form-input" appearance="outline" hideRequiredMarker>
                        <mat-label>Organization<span class="required-input">*</span></mat-label>
                        <input type="text"
                            placeholder="Select Organization"
                            matInput
                            [formControl]="orgControl"
                            [matAutocomplete]="auto">
                            <mat-error *ngIf="orgControl.invalid">
                                Please select a valid Organization
                            </mat-error>
                        <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onOrgSelectionChanged($event)" [displayWith]="displayOrgFn">
                            <mat-option *ngFor="let organization of filteredOrganizations | async" [value]="organization">
                                {{ organization.organization_name }}
                            </mat-option>
                        </mat-autocomplete>    
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Reference ID</mat-label>
                        <input type="text" matInput placeholder="Enter Reference ID" formControlName="property_reference_id" data-testid="property_reference_id">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Property Name<span class="required-input">*</span></mat-label>
                        <input type="text" matInput placeholder="Enter Property Name" formControlName="property_name" data-testid="property_name">
                        <mat-error *ngIf="form.get('property_name')?.invalid">Required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Property Type<span class="required-input">*</span></mat-label>
                        <mat-select formControlName="property_type" data-testid="property_type">
                            <mat-option [value]=1>Apartment</mat-option>
                            <mat-option [value]=2>Townhouse</mat-option>
                            <mat-option [value]=3>Single Family House</mat-option>
                            <mat-option [value]=5>Other</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('property_type')?.invalid">Required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Accommodates</mat-label>
                        <input type="number" step="1" matInput formControlName="accommodates" data-testid="accommodates">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Bedrooms</mat-label>
                        <input type="number" step="1" matInput formControlName="bedrooms" data-testid="bedrooms">
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Bathrooms</mat-label>
                        <input type="number" step="1" matInput formControlName="bathrooms" data-testid="bathrooms">
                    </mat-form-field>
                </div>
                <div class="col d-flex flex-column">
                    <mat-form-field appearance="outline">
                        <mat-label>Description</mat-label>
                        <textarea matInput formControlName="description" data-testid="description"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <mat-action-row class="mt-4 d-flex flex-row align-content-center">
                <div class="d-flex align-items-center text-muted" style="margin-right: auto;">
                    <span class="required-input">*</span>&nbsp;- Required fields before submitting property
                </div>
            </mat-action-row>
        </form>
    </div>
</mat-expansion-panel>